import {Component} from '@angular/core';
import {AlertController, App, NavController, NavParams} from 'ionic-angular';
import {TwitterSettingsFollowings} from "../twitter-settings-followings/twitter-settings-followings";
import {TwitterSettingsKeywords} from "../twitter-settings-keywords/twitter-settings-keywords";
import {TwitterLogin} from "../twitter-login/twitter-login";
import {StorageService} from "../../providers/storage";
import {SocialService} from "../../providers/social-service";
import {TwitterLogout} from "../twitter-logout/twitter-logout";

@Component({
  selector: 'page-twitter-settings',
  templateUrl: 'twitter-settings.html',
})
export class TwitterSettings {
  twitterSettingsFollowings = TwitterSettingsFollowings;
  twitterSettingsKeywords = TwitterSettingsKeywords;
  twitterLogout = TwitterLogout;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private storageService: StorageService,
              private app: App,
              private socialService: SocialService,
              private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    if (parseInt(this.storageService.get('socialUserId')) === 0) {
      let nav = this.app.getRootNav();
      nav.setRoot(TwitterLogin);
    }
  }

  logout() {
    let confirm = this.alertCtrl.create({
      title: 'Sei sicuro?',
      message: 'Confermi l\'uscita da twitter?',
      buttons: [
        {
          text: 'Annulla',
          handler: () => {
            // console.log('Disagree clicked');
            let nav = this.app.getRootNav();
            nav.setRoot(TwitterSettings);
          }
        },
        {
          text: 'Esci',
          handler: () => {
            // console.log('Agree clicked');
            this.socialService.logout().subscribe(
              (data) => {
                // console.log(data);
              },
              (err) => {
                // console.log(err);
              },
              () => {
                this.socialService.disconnect();
                let nav = this.app.getRootNav();
                nav.setRoot(TwitterLogin);
              }
            )
          }
        }
      ]
    });
    confirm.present();


  }

}



// WEBPACK FOOTER //
// ./src/pages/twitter-settings/twitter-settings.ts